var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":require("../assets/img/symbol.png"),"max-height":"150"}})
}
var staticRenderFns = []

export { render, staticRenderFns }